import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import '../../styles/textStyle.css';
import '../hooks/useAutofillEvent.css';
import './BaseInput.css';
export var clearIconButton = '_1a8lqy9e-3-5-0';
export var container = '_1a8lqy98-3-5-0';
export var containerPadding = {none:'_1a8lqy99-3-5-0',rightNone:'_1a8lqy9a-3-5-0',rightUnset:'_1a8lqy9b-3-5-0',leftUnset:'_1a8lqy9c-3-5-0'};
export var disabled = '_1a8lqy92-3-5-0';
export var divider = '_1a8lqy9f-3-5-0';
export var hasError = '_1a8lqy91-3-5-0';
export var input = '_1a8lqy9d-3-5-0 _yfwka33-3-5-0 _da9a8v0-3-5-0 _da9a8v2-3-5-0 _da9a8v3-3-5-0 _da9a8vb-3-5-0';
export var isAutoFilled = '_1a8lqy9g-3-5-0';
export var readOnly = '_1a8lqy93-3-5-0';
export var variant = {'default':'_1a8lqy94-3-5-0',minimal:'_1a8lqy95-3-5-0'};
export var wrapper = '_1a8lqy90-3-5-0';